// extracted by mini-css-extract-plugin
module.exports = {"root":"pagination_root__vtPmI"};